<template>
  <div>
    <button
      v-if="qrcreate.imageData"
      @click="clearSession()"
      class="bg-white h-[44px] px-10 rounded-sm text-success border border-success text-center flex items-center justify-center mx-auto mt-8"
    >
      {{ dataLocales.data.an }}
    </button>
    <button
      v-else
      @click="$emit('generate')"
      class="bg-success-bold h-[44px] px-10 rounded-sm text-white text-center flex items-center justify-center mx-auto mt-8"
    >
      {{ dataLocales.data.gen }}
    </button>
    <button
      class="mt-4 flex items-center justify-center gap-2 w-fit mx-auto hover:text-success font-bold text-sm"
      @click="qrcreate.history_modal = true"
    >
      <HistoryIcon size="20" /> {{$t('recent_qrcodes')}}
    </button>
    <ClientOnly>
      <ToolsHistoryQrCodeModal />
    </ClientOnly>
  </div>
</template>
<script lang="ts" setup>
import DataLocale from "~~/config/interface/DataLocale";
import { useQrCreateStore } from "~~/stores/qrcreate";
import { HistoryIcon } from "vue-tabler-icons";

const qrcreate = useQrCreateStore();
const qrstyle = useQrStyle();
const emit: Function = defineEmits();
const clearSession = () => {
  qrstyle.ClearSession();
  emit("clearSession");
};
const dataLocales = new DataLocale([
  {
    locale: "en",
    gen: "Generate Qr Code",
    an: "Another Build",
  },
  {
    locale: "vi",
    gen: "Tạo mã QR",
    an: "Tạo mới",
  },
  {
    locale: "de",
    gen: "QR-Code generieren",
    an: "Neues erstellen",
  },
  {
    locale: "fr",
    gen: "Générer un code QR",
    an: "Nouvelle création",
  },
  {
    locale: "es",
    gen: "Generar código QR",
    an: "Otra creación",
  },
  {
    locale: "pt",
    gen: "Gerar código QR",
    an: "Outra criação",
  },
  {
    locale: "it",
    gen: "Genera codice QR",
    an: "Nuova creazione",
  },
  {
    locale: "ja",
    gen: "QRコードを生成する",
    an: "別の作成",
  },
  {
    locale: "zh",
    gen: "生成二维码",
    an: "新建",
  },
  {
    locale: "nl",
    gen: "QR-code genereren",
    an: "Nieuwe aanmaken",
  },
]);
</script>
